import React, { useState } from "react";
import { setTokens } from "../utils/jwt";
import { useAuth } from "../context/AuthContext";

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { setIsAuthenticated } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }

      // Store tokens
      setTokens(data.data.accessToken, data.data.refreshToken);
      setIsAuthenticated(true);
      // Call the success callback
      onLoginSuccess?.();

      // Close the modal
      onClose();
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box modal-margins">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        <h2>Admin Login</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="username">Username:</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                borderRadius: 8,
                border: "1px solid #ddd",
                marginTop: 4,
              }}
              required
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label htmlFor="password">Password:</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: "100%",
                padding: "0.5rem",
                borderRadius: 8,
                border: "1px solid #ddd",
                marginTop: 4,
              }}
              required
            />
          </div>
          {error && (
            <div style={{ color: "#e11d48", marginBottom: 12 }}>{error}</div>
          )}
          <div style={{ display: "flex", gap: "10px", marginTop: 20 }}>
            <button
              type="submit"
              className="reset-btn"
              style={{ flex: 1 }}
              disabled={isLoading}
            >
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <div className="button-spinner"></div>
                  <span>Logging in...</span>
                </div>
              ) : (
                <span>Login</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
